const initialState = {
  fetching: false,
};

export default function learnExerciseReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'LEARNEXERCISE_FETCHING':
      return { ...currentState, fetching: true };
    case 'LEARNEXERCISE_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
